import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
import { IconButton } from 'web/src/app/root/components/common'
import { mdiTrashCanOutline, mdiPencilOutline } from '@mdi/js'
import { Modal } from 'web/src/app/root/components/common'
import Button from 'web/src/app/root/components/common/button'

export const CommentCardFooter = ({
    comment,
    isCommentInEditMode,
    editComment,
    locale,
    setIsDeleteCommentModalOpen,
    isDeleteCommentModalOpen,
    setCommentIdToDelete,
    deleteComment,
    commentIdToDelete,
    report
}) => {
    const classes = useStyles()
    const { imagesLoader } = useSelector(state => state.reports)

    return (
        <Box className={classes.commentButtonSection}>
            {!isCommentInEditMode && !imagesLoader && (
                <>
                    <IconButton
                        icon={mdiPencilOutline}
                        onClick={() => {
                            editComment(comment.text, comment.id)
                        }}
                        size={0.8}
                    />

                    <IconButton
                        icon={mdiTrashCanOutline}
                        onClick={() => {
                            setIsDeleteCommentModalOpen(true),
                                setCommentIdToDelete(comment.id)
                        }}
                        size={0.8}
                    />
                </>
            )}
            <Modal open={isDeleteCommentModalOpen}>
                <Box>
                    {locale.reports.deleteConfirmation}
                    <br />
                </Box>
                <Box className={classes.modalButtons}>
                    <Button
                        onClick={() => {
                            deleteComment(commentIdToDelete, report)
                        }}>
                        {locale.reports.delete}
                    </Button>
                    <Button
                        reverted
                        onClick={() => setIsDeleteCommentModalOpen(false)}>
                        {locale.reports.cancle}
                    </Button>
                </Box>
            </Modal>
        </Box>
    )
}
